<template>
  <div class="application_form">
    <template v-if="isShowBtn">
      <div class="match_list">
        <span class="match_title">赛事名称：</span>
        <el-select
          :popper-append-to-body="false"
          style="width:300px"
          v-model="query.raceName"
          placeholder="请选择赛事"
          @change="selectMatch"
        >
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </div>
      <p class="school_name">
        <span class="common_title" style="margin-right:10px;letter-spacing:2.3px">单位名称:</span>
        {{userInfo.schoolName}}
      </p>
      <div class="leader">
        <p class="common_title">
          <span>领</span>
          <span>队：</span>
        </p>
        <el-input style="width:486px" placeholder="输入姓名、多人请用顿号间隔开" v-model="query.leaderName"></el-input>
      </div>
      <div class="coach">
        <p class="common_title">
          <span>教</span>
          <span>练：</span>
        </p>
        <el-select
          :popper-append-to-body="false"
          style="width:486px"
          placeholder="支持单选/多选"
          v-model="query.coachIds"
          multiple
        >
          <el-option
            v-for="(item,index) in coachList"
            :key="index"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </div>
      <el-table
        style="width:100%;margin-top:20px"
        border
        :data="tableData"
      >
        <el-table-column label="序号" align="center" width="60">
          <template slot-scope="{row,$index}">
            <div @click="addTable" style="cursor:pointer" v-if="row.isAdd">+</div>
            <template v-else>{{$index + 1}}</template>
          </template>
        </el-table-column>
        <el-table-column label="组别" align="center" width="60">
          <template slot-scope="{$index,row}">
            <span>{{row.group == 1?'甲组':row.group == 2?'乙组':row.group == 4?'丙组':row.group == 3?'丁组':''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="性别" align="center" width="60" prop="gender"></el-table-column>
        <el-table-column label="姓名" align="center" minWidth="100">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'name','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectAthlete($event,$index,'name')"
                style="height:30px"
                v-if="editable[$index].name"
                v-model="row.name"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'name')"
                class="editRemarkInput"
              >
                <el-option
                  v-for="item in athleteList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
              <div class="cell" v-else>{{row.name}}</div>
            </div>
            <span v-else>{{row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="身份证号码" align="center" width="160" prop="idCard"></el-table-column>
        <el-table-column
          :render-header="(h,obj)=>renderHeader(h,obj,'ws1')"
          align="center"
          width="160"
        >
          <template slot-scope="{row,column,$index}">
            <div
              v-if="(publishState === 0 || publishState === 2)"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'ws1','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].ws1"
                v-model="row.ws1"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'ws1')"
                class="editRemarkInput"
              >
                <el-option value="长拳" label="长拳"></el-option>
                <el-option value="南拳" label="南拳"></el-option>
                <el-option value="太极拳" label="太极拳"></el-option>
              </el-select>
              <span v-else>{{row.ws1}}</span>
            </div>
            <span v-else>{{row.ws1}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :render-header="(h,obj)=>renderHeader(h,obj,'ws2')"
          align="center"
          width="160"
        >
          <template slot-scope="{row,column,$index}">
            <div
              v-if="(publishState === 0 || publishState === 2)"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'ws2','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].ws2"
                v-model="row.ws2"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'ws2')"
                class="editRemarkInput"
              >
                <el-option value="剑" label="剑"></el-option>
                <el-option value="刀" label="刀"></el-option>
                <el-option value="太极剑" label="太极剑"></el-option>
                <el-option value="南刀" label="南刀"></el-option>
              </el-select>
              <span v-else>{{row.ws2}}</span>
            </div>
            <span v-else>{{row.ws2}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :render-header="(h,obj)=>renderHeader(h,obj,'ws3')"
          align="center"
          width="160"
        >
          <template slot-scope="{row,column,$index}">
            <div
              v-if="(publishState === 0 || publishState === 2)"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'ws3','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].ws3"
                v-model="row.ws3"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'ws3')"
                class="editRemarkInput"
              >
                <el-option value="枪" label="枪"></el-option>
                <el-option value="棍" label="棍"></el-option>
                <el-option value="南棍" label="南棍"></el-option>
              </el-select>
              <span v-else>{{row.ws3}}</span>
            </div>
            <span v-else>{{row.ws3}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          :render-header="(h,obj)=>renderHeader(h,obj,'ws4')"
          align="center"
          width="100"
        >
          <template slot-scope="{row,column,$index}">
            <div
              v-if="(publishState === 0 || publishState === 2)"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'ws4','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].ws4"
                v-model="row.ws4"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'ws4')"
                class="editRemarkInput"
              >
                <el-option value="太极剑" label="太极剑"></el-option>
              </el-select>
              <span v-else>{{row.ws4}}</span>
            </div>
            <span v-else>{{row.ws4}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :render-header="(h,obj)=>renderHeader(h,obj,'ws5')"
          align="center"
          width="120"
        >
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'ws5','editRemarkInput')}}"
            >
              <el-input
                v-if="editable[$index].ws5"
                v-model.trim="row.ws5"
                size="mini"
                @blur="$event=>handleBlur($event,$index,'ws5')"
                class="editRemarkInput"
              ></el-input>
              <span v-else>{{row.ws5}}</span>
            </div>
            <span v-else>{{row.ws5}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :render-header="(h,obj)=>renderHeader(h,obj,'ws6')"
          align="center"
          width="120"
        >
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'ws6','editRemarkInput')}}"
            >
              <el-input
                v-if="editable[$index].ws6"
                v-model.trim="row.ws6"
                size="mini"
                @blur="$event=>handleBlur($event,$index,'ws6')"
                class="editRemarkInput"
              ></el-input>
              <span v-else>{{row.ws6}}</span>
            </div>
            <span v-else>{{row.ws6}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :render-header="(h,obj)=>renderHeader(h,obj,'ws7')"
          align="center"
          width="100"
        >
          <template slot-scope="{row,column,$index}">
            <div
              v-if="(publishState === 0 || publishState === 2)"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'ws7','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].ws7"
                v-model="row.ws7"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'ws7')"
                class="editRemarkInput"
              >
                <el-option value="品势单人" label="品势单人"></el-option>
              </el-select>
              <span v-else>{{row.ws7}}</span>
            </div>
            <span v-else>{{row.ws7}}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          :render-header="(h,obj)=>renderHeader(h,obj,'ws8')"
          align="center"
          width="100"
        >
          <template slot-scope="{row,column,$index}">
            <div
              v-if="(publishState === 0 || publishState === 2)"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'ws8','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].ws8"
                v-model="row.ws8"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'ws8')"
                class="editRemarkInput"
              >
                <el-option value="品势团体" label="品势团体"></el-option>
              </el-select>
              <span v-else>{{row.ws8}}</span>
            </div>
            <span v-else>{{row.ws8}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="备注" align="center" width="100">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'remarks','editRemarkInput')}}"
            >
              <el-input
                v-if="editable[$index].remarks"
                v-model.trim="row.remarks"
                size="mini"
                @blur="$event=>handleBlur($event,$index,'remarks')"
                class="editRemarkInput"
              ></el-input>
              <span v-else>{{row.remarks}}</span>
            </div>
            <span v-else>{{row.remarks}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="{row,$index}">
            <el-button
              v-if="!row.isAdd && (publishState !== 1 && publishState !== 3)"
              type="text"
              style="color:rgb(252, 91, 91);"
              @click="deleteRow($index)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <footer v-if="publishState === 0 || publishState === 2">
        <template v-if="query.matchId">
          <el-button
            :loading="loadingData.submitLoading"
            class="btns"
            @click="submits('submit')"
          >确认提交</el-button>
          <el-button
            :loading="loadingData.saveLoading"
            class="btns"
            @click="submits('save')"
            style="margin:0 20px;"
          >保存草稿</el-button>
          <el-button class="btns" @click="clearData">清空重置</el-button>
        </template>
      </footer>
      <footer v-else>
        <span style="font-size:22px">审核状态：</span>
        <span
          :style="{color:publishState === 1?'#1E63B0':'#1CC28C'}"
          style="font-size:18px"
        >{{publishState === 1?'待审核':'审核已通过'}}</span>
      </footer>
    </template>
    <template v-else>
      <div style="padding:160px 0 0 250px">
        <img src="../../assets/img/signUp/no_data.png" alt />
      </div>
    </template>
    <div
      v-if="!hideMask"
      style="width:100%;height:100vh;position:fixed;background:#fff;top:106px;z-index:999999;left:290px;"
    ></div>
  </div>
</template>
<script>
import {
  addSign,
  updateSign,
  getSignDetailBySchool,
  getSignListBySchool
} from "@/api/sign-up-match";
import { getMatchList } from "@/api/sports-management";
import { table, message } from "@/common/js/mixins";
import { getSession } from "@/utils/storage.js";
import { getCoachList, getAthleteList } from "@/api/athletes.js";
export default {
  mixins: [table, message],
  data() {
    return {
      query: {
        raceName: "",
        matchId: "",
        id: "",
        leaderName: "",
        coachIds: []
      },
      editable: [],
      titles: [
        "name",
        "idCard",
        "ws1",
        "ws2",
        "ws3",
        // "ws4",
        // "ws5",
        // "ws6",
        // "ws7",
        // "ws8",
        "remarks"
      ],
      coachList: [],
      rules: {
        raceName: [
          {
            required: true,
            message: "赛事名称不能为空",
            trigger: "blur"
          }
        ]
      },
      matchList: [],
      athleteList: [],
      loadingData: {
        submitLoading: false,
        saveLoading: false
      },
      userInfo: JSON.parse(getSession("userInfo")),
      publishState: 0,
      hideMask: false,
      isShowBtn: true,
      currentProject: {}
    };
  },
  methods: {
    // 删除表格列
    deleteRow(index) {
      this.tableData.splice(index, 1);
    },
    // 添加表格行
    addTable() {
      let obj = {
        isAdd: false,
        athleteId: "",
        group: "",
        gender: "",
        name: "",
        idCard: "",
        ws1: "",
        ws2: "",
        ws3: "",
        // ws4: "",
        // ws5: "",
        // ws6: "",
        // ws7: "",
        // ws8: "",
        remarks: ""
      };
      this.tableData.splice(this.tableData.length - 1, 0, obj);
      let objs = {};
      this.titles.filter(temp => {
        objs[temp] = false;
      });
      this.editable.splice(this.editable.length - 1, 0, objs);
    },
    // 表格点击显示对应下拉菜单或输入框
    changeNum(index, row, className) {
      this.editable.filter(item => {
        for (let temp in item) item[temp] = false;
      });
      if(row == 'ws5' && !this.currentProject.otherBoxing) {
        return this.openWarn("当前赛事未设置南拳，请设置后填写");
      }
      if(row == 'ws6' && !this.currentProject.otherApparatus) {
        return this.openWarn("当前赛事未设置南刀，请设置后填写");
      }
      if (this.tableData[index]["isAdd"]) return;
      this.editable[index][row] = true;
      if (
        this.tableData[index][row] === "输入" ||
        this.tableData[index][row] === "非必填项"
      )
        this.$set(this.tableData[index], row, "");
      //让input自动获取焦点
      this.$nextTick(() => {
        var editInputList = document.getElementsByClassName(className);
        if (row !== "remarks" && row !== "ws5" && row !== "ws6") {
          editInputList[0].children[0].children[0].focus();
        } else {
          editInputList[0].children[0].focus();
        }
      });
    },
    // 表格下拉框或输入框离开焦点
    handleBlur(e, index, col) {
      setTimeout(() => {
        this.editable[index][col] = false;
      }, 200);
    },
    // 选择运动员
    selectAthlete(value, num, col, details = false) {
      if (value) {
        // this.athleteList.filter((item, index) => {
        //   this.$set(this.athleteList[index], "disabled", false);
        // });
        let arr = [];
        if (!details) this.$set(this.tableData[num], "athleteId", "");

        // this.tableData.filter((item, i) => {
        for (let j = 0; j < this.athleteList.length; j++) {
          if (
            this.tableData[num].name === this.athleteList[j].id ||
            this.tableData[num].athleteId === this.athleteList[j].id
          ) {
            // this.$set(this.athleteList[j], "disabled", true);
            this.$set(this.athleteList[j], "numbers", num);
            arr.push(this.athleteList[j]);
            break;
          }
        }
        // });
        arr.filter((item, i) => {
          for (let t in item) {
            if (this.tableData[item.numbers].hasOwnProperty(t)) {
              if (t !== "coachId") {
                if (t === "gender") {
                  this.$set(
                    this.tableData[item.numbers],
                    t,
                    item[t] === 0 ? "女子" : "男子"
                  );
                } else if (t !== "remarks")
                  this.$set(this.tableData[item.numbers], t, item[t]);
              }
            }
            Object.assign(this.tableData[item.numbers], {
              athleteId: item.id
            });
          }
        });
      } else {
        Object.assign(this.tableData[num], {
          group: "",
          idCard: "",
          gender: ""
        });
      }
    },
    // 获取当前赛事运动员列表（草稿）
    getAthleteListByDraft() {
      return new Promise((resolve, reject) => {
        getAthleteList({
          pageNo: 1,
          pageSize: 999,
          isPass: 1,
          effective: 1,
          isOld: 0,
          groupId: this.currentProject.groupId,
          gender:
            this.currentProject.gender === -1 ? "" : this.currentProject.gender
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    renderHeader(h, { column, $index }, key) {
      if (key == "ws5" || key == "ws6") {
        return h(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              lineHeight: "1"
            }
          },
          [
            h("p", {}, [
              h(
                "span",
                {
                  style: {
                    fontSize: "15px"
                  }
                },
                key == "ws5" ? "南拳" : "南刀"
              ),
              h(
                "span",
                {
                  style: {
                    fontSize: "12px"
                  }
                },
                "（单项）"
              )
            ]),
            h(
              "p",
              {
                style: {
                  fontSize: "12px",
                  marginTop: "4px"
                }
              },
              "（备注项目）"
            )
          ]
        );
      } else if (key == "ws7" || key == "ws8") {
        return h(
          "div",
          {
            style: {
              lineHeight: "1"
            }
          },
          [
            h(
              "p",
              {
                style: {
                  fontSize: "15px"
                }
              },
              key == "ws7"?"南棍":"品势：团体"
            ),
            h(
              "p",
              {
                style: {
                  fontSize: "12px",
                  marginTop: "4px"
                }
              },
              key == "ws7" ? "（单项）" : "（多人）"
            )
          ]
        );
      }
      return h(
        "div",
        {
          style: {
            // lineHeight: "1"
          }
        },
        [
          h(
            "p",
            {
              style: {
                fontSize: "15px",
                // marginBottom: "4px"
              }
            },
            key == "ws1"
              ? "自选拳术（单项）"
              : key == "ws2"
              ? "自选短器械（单项）"
              : key == "ws3"
              ? "自选长器械（单项）"
              : "太极剑"
          ),
          // h(
          //   "span",
          //   {
          //     style: {
          //       fontSize: "12px"
          //     }
          //   },
          //   "（单项）"
          // )
        ]
      );
    },
    // 获取当前赛事运动员列表
    getAthleteLists() {
      getAthleteList({
        pageNo: 1,
        pageSize: 999,
        effective: 1,
        isPass: 1,
        isOld: 0,
        groupId: this.currentProject.groupId,
        gender:
          this.currentProject.gender === -1 ? "" : this.currentProject.gender
      })
        .then(res => {
          if (res.list.length === 0) {
            this.openWarn("当前组别无运动员数据");
          }
          res.list.filter(item => {
            item.disabled = false;
          });
          this.makeTable();
          this.athleteList = [...res.list];
        })
        .catch(err => {});
    },
    // 根据赛事限制人数生成表格
    makeTable(count = this.currentProject.allCountText, isPass = null) {
      this.tableData = [];
      this.editable = [];
      for (let i = 0; !isPass ? i <= count : i < count; i++) {
        let objs = {
          isAdd: i == count ? true : false,
          athleteId: "",
          group: "",
          gender: "",
          name: "",
          idCard: "",
          ws1: "",
          ws2: "",
          ws3: "",
          // ws4: "",
          // ws5: "",
          // ws6: "",
          // ws7: "",
          // ws8: "",
          remarks: ""
        };
        this.tableData.push({ ...objs });
        let obj = {};
        this.titles.filter(temp => {
          obj[temp] = false;
        });
        this.editable.push(obj);
      }
    },
    // 获取教练员列表
    getCoachLists() {
      getCoachList({
        // project: 2
      })
        .then(res => {
          this.coachList = [...res];
        })
        .catch(err => {});
    },
    // 选择赛事
    selectMatch(value) {
      Object.assign(this.query, this.$options.data().query);
      this.athleteList = [];
      let data = {};
      this.matchList.filter(item => {
        if (item.id === value) data = item;
      });
      this.currentProject = data;
      Object.assign(this.query, {
        matchId: data.id,
        raceName: value
      });
      this.getSignDetail(value);
    },
    // 获取详情，如果有数据，则表示已经提交或草稿数据，如果审核已通过，则修改表格显示数量
    getSignDetail(id) {
      getSignDetailBySchool({ matchId: id })
        .then(res => {
          if (res) {
            this.publishState = res.state;
            Object.assign(this.query, {
              coachIds: res.coachIds.split(","),
              leaderName: res.leaderName,
              id: res.id
            });
            this.getAthleteListByDraft()
              .then(data => {
                data.list.filter(item => {
                  item.disabled = false;
                });
                this.athleteList = [...data.list];
                if (res.state === 3 || res.state === 1) this.makeTable(res.athleteList.length,'pass');
                else this.makeTable();
                res.athleteList.filter((item, index) => {
                  Object.assign(this.tableData[index], {
                    name: item.athleteName,
                    remarks: item.remarks,
                    athleteId: item.athleteId,
                    ws1:item.projectJson.ws1,
                    ws2:item.projectJson.ws2,
                    ws3:item.projectJson.ws3,
                    // ws4:item.projectJson.ws4,
                    // ws5:item.projectJson.ws5,
                    // ws6:item.projectJson.ws6,
                    // ws7:item.projectJson.ws7,
                    // ws8:item.projectJson.ws8
                  });
                  this.selectAthlete(item.athleteId, index, "name", true);
                });
              })
              .catch(err => {});
          } else {
            this.publishState = 0;
            this.getAthleteLists();
            this.makeTable();
          }
        })
        .catch(err => {});
    },
    // 获取赛事列表
    getMatch() {
      getMatchList({
        project: 2,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.matchList = res.list;
          this.isShowBtn = res.list.length === 0 ? false : true;
          this.hideMask = true;
          if (this.$route.query.id) this.selectMatch(this.$route.query.id);
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowBtn = false;
          }
          this.hideMask = true;
        });
    },
    // 提交/草稿
    submits(type, pass = null) {
      let data = this.formData(type, pass);
      if (!data) return;
      if (!this.query.id) {
        type == "submit"
          ? (this.loadingData.submitLoading = true)
          : (this.loadingData.saveLoading = true);
        addSign({
          ...this.query,
          coachIds: this.query.coachIds.join(","),
          ...data,
          state: type === "submit" ? 1 : 0
        })
          .then(res => {
            type == "submit"
              ? (this.loadingData.submitLoading = false)
              : (this.loadingData.saveLoading = false);

            this.openSuccess(
              type === "submit" ? "恭喜你，报名成功！" : "保存成功！"
            );

            this.$router.push({
              path: "/martial/martial-registration-form-view",
              query: {
                id: this.query.raceName
              }
            });
          })
          .catch(err => {
            type == "submit"
              ? (this.loadingData.submitLoading = false)
              : (this.loadingData.saveLoading = false);
          });
      } else {
        type == "submit"
          ? (this.loadingData.submitLoading = true)
          : (this.loadingData.saveLoading = true);
        updateSign({
          ...this.query,
          ...data,
          coachIds: this.query.coachIds.join(","),
          state: type === "submit" ? 1 : 0
        })
          .then(res => {
            type == "submit"
              ? (this.loadingData.submitLoading = false)
              : (this.loadingData.saveLoading = false);
            this.openSuccess(
              type === "submit" ? "恭喜你，报名成功！" : "保存成功！"
            );

            this.$router.push({
              path: "/martial/martial-registration-form-view",
              query: {
                id: this.query.raceName
              }
            });
          })
          .catch(err => {
            type == "submit"
              ? (this.loadingData.submitLoading = false)
              : (this.loadingData.saveLoading = false);
          });
      }
    },
    // 格式化数据
    formData(type, pass) {
      let athleteJson = [];
      let warnText = "";
      let flag = false;
      let num = 0;
      let { leaderName, coachIds } = this.query;
      if (!leaderName) {
        return this.openWarn("领队不为空");
      }
      if (coachIds.length == 0) {
        return this.openWarn("教练不能为空");
      }
      /**
       * 循环表格，判断所有列中是否有一列选择姓名，如果没有，给与提示
       */
      this.tableData.forEach(item => {
        if (!flag) {
          if (!item.name && !item.isAdd) {
            num++;
          }
          if (
            item.name &&
            !item.ws1 &&
            !item.ws2 &&
            !item.ws3 
            // &&
            // !item.ws4 &&
            // !item.ws7 
            // !item.ws8
          ) {
            if (
              this.currentProject.otherBoxing &&
              this.currentProject.otherApparatus &&
              !item.ws5 &&
              !item.ws6
            ) {
              warnText = "至少选择一个比赛项目";
              flag = true;
              return;
            } else if (
              !this.currentProject.otherBoxing &&
              !this.currentProject.otherApparatus
            ) {
              warnText = "至少选择一个比赛项目";
              flag = true;
              return;
            } else if (
              this.currentProject.otherBoxing &&
              !this.currentProject.otherApparatus &&
              !item.ws5
            ) {
              warnText = "至少选择一个比赛项目";
              flag = true;
              return;
            } else if (
              !this.currentProject.otherBoxing &&
              this.currentProject.otherApparatus &&
              !item.ws6
            ) {
              warnText = "至少选择一个比赛项目";
              flag = true;
              return;
            }
          }
          if (item.name) {
            athleteJson.push({
              athleteId: item.athleteId,
              remarks: item.remarks,
              projectJson: {
                ws1: item.ws1,
                ws2: item.ws2,
                ws3: item.ws3,
                // ws4: item.ws4,
                // ws5: this.currentProject.otherBoxing ? item.ws5 : undefined,
                // ws6: this.currentProject.otherApparatus ? item.ws6 : undefined,
                // ws7: item.ws7,
                // ws8: item.ws8
              }
            });
          }
        }
      });
      if (num == this.tableData.length - 1) {
        warnText = "请至少选择一个运动员后进行操作";
      }
      if (warnText) return this.openWarn(warnText);

      return {
        athleteJson: JSON.stringify(athleteJson)
      };
    },
    // 清空重置
    clearData() {
      this.tableData.filter((item, index) => {
        for (let temp in item) {
          if (temp === "partTime" || temp === "test" || temp === "mark") {
            this.$set(this.tableData[index], temp, "FALSE");
          } else if (temp === "score") {
            this.$set(this.tableData[index], temp, "99:99.99");
          } else if (temp !== "schoolName") {
            this.$set(this.tableData[index], temp, "");
          }
        }
      });
      this.editable.filter((item, index) => {
        for (let temp in item) {
          this.$set(this.editable[index], temp, false);
        }
      });
      window.scrollTo(0, 0);
    }
  },
  mounted() {
    this.getMatch();
    this.getCoachLists();
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/font/pfSembold.css";
@import '../../assets/font/pf.css';
.application_form {
  /deep/ .el-form-item__label {
    font-size: 16px;
    color: #000;
  }
  /deep/ .el-table .cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  /deep/ .el-table thead {
    color: #444;
    font-size: 15px;
    th {
      background: #eee;
      border-right: 1px solid #ddd;
    }
  }
  /deep/ .el-table--border,
  .el-table--group {
    border: 1px solid #ddd;
  }
  /deep/ .el-table td,
  /deep/ .el-table th.is-leaf {
    padding: 4px 0;
  }
  .match_list {
    margin: 0 0 20px;
    .match_title {
      font-size: 16px;
      margin-right: 10px;
      font-family: PF;
    }
  }
  .school_name,
  .coach,
  .leader {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-family: pfSem;
    /deep/ .el-input__inner {
      border-left: none;
      border-right: none;
      border-top: none;
      border-radius: 0;
    }
  }
  .leader {
    margin: 10px 0;
  }
  .common_title {
    width: 82px;
    display: flex;
    justify-content: space-between;
  }
  footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
    .btns {
      margin: 0;
      color: #1e63b0;
      border: 1px solid #1e63b0;
    }
  }
}
</style>